/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import MyTrainingPresenter from "./MyTrainingPresenter";
import DTOMytraining from "./DTOMytraining";
import { useTranslation } from "react-i18next";

const MyTrainingController = () => {
  const { t, i18n } = useTranslation();
  const [mytrainingData, setmytrainingData] = useState([]);
  const [textFilter] = useState([]);

  function callBackFunc(data: any) {
    setmytrainingData(data);
  }

  return (
    <>
      <DTOMytraining
        setMytrainingDatas={callBackFunc}
        textFilter={textFilter}
      />
      <MyTrainingPresenter
        mytrainingData={mytrainingData}
        trans={t}
        i18n={i18n}
      />
    </>
  );
};
export default MyTrainingController;
